function filterTagIds(tagCollection = [], tagIdsToFilter) {
    let newIds = [];
    const existingIds = [];
    if (!tagCollection.length) {
        newIds = tagIdsToFilter;
    }
    else {
        tagIdsToFilter.forEach(tagId => {
            if (tagCollection.indexOf(tagId) !== -1) {
                existingIds.push(tagId);
            }
            else {
                newIds.push(tagId);
            }
        });
    }
    return {
        newIds,
        existingIds,
    };
}
export default filterTagIds;
//# sourceMappingURL=filterTagIds.js.map